// extracted by mini-css-extract-plugin
module.exports = {"bannerMedio":"BannerMedio_bannerMedio__l1Sel","cbannerMedio":"BannerMedio_cbannerMedio__wenwl","bannerMedioWide":"BannerMedio_bannerMedioWide__oYIL_"};